module.exports = __webpack_public_path__ + "static/media/workshop-main.03858ea1.svg";